<template>
  <div>
    <listado-clientes-terrestres-tabla />
  </div>
</template>

<script>

  // Vuex
  import { mapActions } from "vuex";
  import ListadoClientesTerrestresTabla from '../../../components/tablas/tarifas/ListadoClientesTerrestresTabla.vue';

  export default {

    components: { ListadoClientesTerrestresTabla },

    methods: {

      // Acciones de Vuex
      ...mapActions(["AccionCambiar"]),
    

      // Función para actualizar url en state
      actualizarURL() {
        let me = this;
        me.AccionCambiar(this.$route.path);
      }

    },

      created() {
      // Ejecución de actualizarURL una vez que se carga el componente
      this.actualizarURL();
    },

  }
</script>

<style>

</style>